import { render, staticRenderFns } from "./total-orders.card.vue?vue&type=template&id=774a99cd&"
import script from "./total-orders.card.vue?vue&type=script&lang=js&"
export * from "./total-orders.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports